export default __webpack_public_path__ + "static/char-s-41-zh-Hans-44fadb34297cc113406180ff8ad0c80d.webp";